const TOKEN_PARAM = "spektrixPasswordToken"

/**
 * Reads the reset token from Spektrix's Change Password email. The email's only merge field is `{link}`,
 * Spektrix's own reset page carrying the token, so the template's button points at this site and passes
 * that link along: `https://<site>/?spektrix-action=reset-password&link={link}`.
 *
 * Spektrix inserts `{link}` unencoded, so its own `&domain=…` splits off into a separate parameter.
 * The token survives either way, and the link itself is never loaded.
 */
export function getPasswordResetToken(params: URLSearchParams): string | null {
  const link = params.get("link")
  if (link) {
    try {
      const token = new URL(link).searchParams.get(TOKEN_PARAM)
      if (token) return token
    } catch {
      // Fall through to a token passed directly.
    }
  }
  return params.get(TOKEN_PARAM)
}

/** Parameters a password reset link brings to the site, which shouldn't stay in the address bar. */
export const PASSWORD_RESET_PARAMS = ["link", "domain", TOKEN_PARAM]
